import { useEffect, useState } from "react";
import { GraduationCap, FileText, FileDown, PlayCircle } from "lucide-react";
import api, { API } from "../lib/api";
import { useAuth } from "../lib/auth";

const fileUrl = (name, download) => {
  const t = localStorage.getItem("access_token");
  const q = new URLSearchParams({ ...(t ? { token: t } : {}), ...(download ? { download: "true" } : {}) }).toString();
  return `${API}/training/file/${encodeURIComponent(name)}${q ? `?${q}` : ""}`;
};

function ManualCard({ m, mine }) {
  return (
    <div className="surface p-5 flex flex-col gap-3" data-testid={`training-manual-${m.role}`}>
      <div className="flex items-center gap-2">
        <FileText size={18} style={{ color: "#ca8a04" }}/>
        <div className="font-display font-extrabold text-base">Manual · {m.label}</div>
        {mine && <span className="pill text-[10px] font-extrabold" style={{ background: "#fef9c3", color: "#854d0e" }}>Tu rol</span>}
      </div>
      <div className="flex flex-wrap gap-2">
        <a className="btn flex items-center gap-2" href={fileUrl(m.pdf)} target="_blank" rel="noreferrer" data-testid={`training-pdf-${m.role}`}>
          <FileText size={14}/> Ver PDF
        </a>
        <a className="btn flex items-center gap-2" href={fileUrl(m.docx, true)} data-testid={`training-docx-${m.role}`}>
          <FileDown size={14}/> Descargar Word
        </a>
      </div>
    </div>
  );
}

export default function TrainingPage() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get("/training/manifest").then((r) => setData(r.data)).catch(() => setError(true)); }, []);

  return (
    <div className="p-4 md:p-8 max-w-[1200px]" data-testid="training-page">
      <div className="flex items-center gap-3 mb-1">
        <GraduationCap size={26} style={{ color: "#ca8a04" }}/>
        <h1 className="font-display text-2xl font-extrabold">Entrenamiento</h1>
      </div>
      <p className="text-sm text-gray-500 font-semibold mb-6">Video de la plataforma y manual de uso según tu rol.</p>
      {error && <div className="surface p-5 text-sm text-red-600 font-semibold" data-testid="training-error">No se pudo cargar el material de entrenamiento.</div>}
      {!data && !error && <div className="surface h-64 animate-pulse" data-testid="training-loading"/>}
      {data && (
        <>
          <section className="surface p-4 md:p-6 mb-6" data-testid="training-video-section">
            <div className="flex items-center gap-2 mb-3">
              <PlayCircle size={18} style={{ color: "#ca8a04" }}/>
              <h2 className="font-display font-extrabold text-lg">Recorrido general de la plataforma</h2>
              <span className="text-xs text-gray-500 font-semibold">· {data.duration} min</span>
            </div>
            <video className="w-full rounded-xl bg-black aspect-video" controls preload="metadata" playsInline
                   src={fileUrl(data.video)} poster={fileUrl("poster.jpg")} data-testid="training-video"/>
            <a className="inline-flex items-center gap-2 mt-3 text-xs font-bold text-gray-600 hover:underline"
               href={fileUrl(data.video, true)} data-testid="training-video-download">
              <FileDown size={13}/> Descargar video
            </a>
          </section>
          <h2 className="font-display font-extrabold text-lg mb-3">{data.manuals.length > 1 ? "Manuales por rol" : "Tu manual"}</h2>
          <div className="grid gap-4 md:grid-cols-3">
            {data.manuals.map((m) => <ManualCard key={m.role} m={m} mine={m.role === user?.role}/>)}
          </div>
        </>
      )}
    </div>
  );
}
